import {
  ImpexAdmin,
  ImpexFinance,
  ImpexOperations,
  SuperAdmin,
  SupplierAdmin,
  SupplierFinance,
  SupplierOperations,
} from "../global-const/permissionName";
import { getRole } from "../services/authService";

export const allowedRolesToAssign = (roleData, selectedUserType, isForEdit=false) => {
  const userRole = getRole();
  var roles = [];
  if (userRole === ImpexOperations) {
    for (const role of roleData) {
      if ([ImpexAdmin, ImpexOperations, ImpexFinance].includes(role.RoleName)) {
        roles.push(role);
      }
    }
  } else if (userRole === SupplierOperations) {
    for (const role of roleData) {
      if ([SupplierOperations, SupplierFinance].includes(role.RoleName)) {
        roles.push(role);
      }
    }
  } else if (userRole === ImpexAdmin) {
    if (selectedUserType === "impex") {
      for (const role of roleData) {
        if (
          [
            ImpexOperations,
            ImpexFinance,
            ImpexAdmin,
          ].includes(role.RoleName)
        ) {
          roles.push(role);
        }
      }
    } else if (selectedUserType === "supplier") {
      for (const role of roleData) {
        if (
          [
            SupplierOperations,
            SupplierFinance,
            SupplierAdmin,
          ].includes(role.RoleName)
        ) {
          roles.push(role);
        }
      }
    }
  } else if (userRole === SupplierAdmin) {
    for (const role of roleData) {
      if (
        [SupplierOperations, SupplierFinance, SupplierAdmin].includes(
          role.RoleName
        )
      ) {
        roles.push(role);
      }
    }
  } else if (userRole === SuperAdmin) {
    if (selectedUserType === "impex") {
      for (const role of roleData) {
        if (
          [
            ImpexOperations,
            ImpexFinance,
            ImpexAdmin,
            ...(!isForEdit ? [SuperAdmin] : []),
          ].includes(role.RoleName)
        ) {
          roles.push(role);
        }
      }
    } else if (selectedUserType === "supplier") {
      for (const role of roleData) {
        if (
          [
            SupplierOperations,
            SupplierFinance,
            SupplierAdmin,
          ].includes(role.RoleName)
        ) {
          roles.push(role);
        }
      }
    } else {
      for (const role of roleData) {
        if (
          [
            ImpexOperations,
            ImpexFinance,
            ImpexAdmin,
            SuperAdmin,
            SupplierOperations,
            SupplierFinance,
            SupplierAdmin,
          ].includes(role.RoleName)
        ) {
          roles.push(role);
        }
      }
    }
  }

  return roles;
};

const characters =
  "EFOz0HIJKhi&ABw4UV123Xc$dWxYCDopqjPQRefgmnGklLMN@rstu56STvZaby789";

export function generateString(length = 8) {
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
